export const revenuePerAvailableNightSelector = (period: string) => (state: any) => state.revenuePerAvailableNight.data; 